import template from "./index.html";
import "./index.less";
import moment from "moment";

import { hasHadState } from "../../utils";
import { REPORT_STATES } from "../../constants";

function controller(appState, $logger) {
	const ctrl = this;

	ctrl.$onChanges = onChanges;
	ctrl.getFormattedTime = getFormattedTime;
	ctrl.hasBeenSubmitted = (report) => hasHadState(REPORT_STATES.submitted.code, report);

	ctrl.$onInit = () => {
		ctrl.form = appState.forms.selected;
		ctrl.canAmend = appState.permissions.Reporting.Actions.CanAmend;
		ctrl.assignedSequences = getAssignedSequences();
		ctrl.status = getReportStatus();
	};

	function onChanges() {
		ctrl.assignedSequences = getAssignedSequences();
		ctrl.status = getReportStatus();
	}

	function getAssignedSequences() {
		return (ctrl.report?.Sequences ?? [])
			.map((sequence) => {
				const typeName = sequence?.Type?.Name;
				const typeCode = sequence?.Type?.Code ?? sequence?.TypeCode ?? sequence?.Code;
				const value = sequence?.Value ?? sequence?.Sequence;
				const assigned = sequence?.Assigned;
				const isDeleted = sequence?.IsDeleted === true || sequence?.Deleted === true;

				if(typeCode === undefined || value === undefined || value === null) {
					return undefined;
				}

				return {
					typeName: typeName ?? typeCode,
					value: `${value}`,
					assigned,
					isDeleted
				};
			})
			.filter(sequence => sequence !== undefined)
			.sort((currentSequence, nextSequence) => {
				if(currentSequence.isDeleted !== nextSequence.isDeleted) {
					return currentSequence.isDeleted ? 1 : -1;
				}

				if(currentSequence.assigned && nextSequence.assigned) {
					return currentSequence.assigned.localeCompare(nextSequence.assigned, undefined, { numeric: true, sensitivity: "base" });
				}

				if(currentSequence.assigned && !nextSequence.assigned) {
					return -1;
				}

				if(!currentSequence.assigned && nextSequence.assigned) {
					return 1;
				}

				return 0;
			});
	}

	function getReportStatus() {
		ctrl.reverseSortedHistory = (ctrl.report.History ?? []).sort((a, b) => moment(a.Occurred).isBefore(b.Occurred) ? 1 : -1);

		if(ctrl.reverseSortedHistory.length === 0) {
			return {
				text: "Pending",
				style: "warning",
				icon: undefined
			};
		}
		else if(ctrl.report.Submitted !== undefined) { // possibly old reports with submitted date but no submitted history record?
			return {
				text: "Completed",
				style: "success",
				icon: "zmdi-check"
			};
		}

		switch(ctrl.reverseSortedHistory[0].State.Code) {
			case "SUBMITTED":
				return {
					text: "Completed",
					style: "success",
					icon: "zmdi-check"
				};

			case "DECLARED":
				return {
					text: "Declared",
					style: "warning",
					icon: undefined
				};

			case "SUBMITTING":
				return {
					text: "Submitting", 
					style: "submitting",
					icon: undefined
				};

			case "PENDING":
				if(ctrl.report.Date === undefined) {
					return {
						text: "Declared",
						style: "warning",
						icon: undefined
					};
				}
				else if(!ctrl.canAmend && hasHadState(REPORT_STATES.submitted.code, ctrl.report)) {
					return {
						text: "Under Review",
						style: "review",
						icon: undefined
					};
				}

				return {
					text: "Pending",
					style: "warning",
					icon: undefined
				};

			case "DELETED":
				return {
					text: "Deleted",
					style: "info",
					icon: "zmdi-delete"
				};

			default:
				return {
					text: "Pending",
					style: "warning",
					icon: undefined
				};
		}
	}

	function getFormattedTime() {
		return moment(ctrl.report.LastModified).local()
			.fromNow();
	}
}

export default angular
	.module("vesl.components.report-status", [])
	.component("reportStatus", {
		template,
		controller,
		bindings: {
			report: "<"
		}
	}).name;
